import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useUser } from "../login/UserContext";
import { useSignalValue } from "../../utils/signal";
import {
  clearProgress,
  loadProgress,
  progressSignal,
} from "../../features/lifecycle/progress-store";
import { billingStripLine, isProductPath } from "./billingLines";
import "./billing-strip.scss";

/** One quiet line on every product page: what you pay, when, and your way out. */
const BillingStrip: React.FC = () => {
  const { pathname } = useLocation();
  const { user, authReady } = useUser();
  const progress = useSignalValue(progressSignal);
  const signedIn = authReady && Boolean(user?.id);
  const onProduct = signedIn && isProductPath(pathname);

  useEffect(() => {
    if (authReady && !user?.id) clearProgress();
  }, [authReady, user?.id]);

  useEffect(() => {
    if (!onProduct) return;
    void loadProgress();
    // Back from the Stripe portal, the old date would be wrong.
    const refresh = () => void loadProgress(true);
    window.addEventListener("focus", refresh);
    return () => window.removeEventListener("focus", refresh);
  }, [onProduct]);

  const line = onProduct && progress ? billingStripLine(progress) : null;
  if (!line) return null;

  return (
    <aside
      className={`billing-strip${line.attention ? " is-attention" : ""}`}
      role="status"
      aria-label="Billing"
    >
      <span className="billing-strip__text">{line.text}</span>
      <Link to="/account-settings" className="billing-strip__link">
        Manage billing
      </Link>
    </aside>
  );
};

export default BillingStrip;
